import {homeLink} from '../common';
import * as mobileCss from './mobile.scss';
import * as desktopCss from './desktop.scss';
import Accordion from './components/Accordion/Accordion';

export default ({mainLinks, t, config, tAll}) => `
<nav class="${mobileCss.navigation}">
  <div class="${desktopCss.aside}">
    <a
      href="${homeLink(config.language)}"
      class="${desktopCss.asideLogo}"
      title="${tAll('title_wix_logo')}"
      tabindex="${config.tabIndex[1]}"
      data-hook="footer-wix-logo"
     >
        Wix.com
     </a>
    <p class="${desktopCss.asideParagraph}" data-hook="description">${t('description')}</p>
    <p class="${desktopCss.asideParagraph}" data-hook="closing_line">${t('closing_line1')} ${t('closing_line2')}</p>
  </div>

  ${Accordion(mainLinks)}

  <div class="${mobileCss.copyrights}" data-hook="closing_years">${t('closing_years')}</div>
</nav>
`;
